import { logErrorMini } from '../services/service-logger/lib/log-error-mini';
import { type ParsedToken } from '../store/app-store/types';
import { parseJSON } from './parse-json';

export const parseJwt = (token: string): ParsedToken | null => {
  if (!token) return null;

  const base64Url = token.split('.')[1];

  if (!base64Url) return null;

  try {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const parsedToken = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return parseJSON<ParsedToken>(parsedToken);
  } catch (err) {
    logErrorMini(err as Error, 'parseJwt');
    console.error(err);
    return null;
  }
};
